import { format } from 'date-fns'
import './ugly-cancellations-popup.css'
const UglyCancellationsPopup = ({cancellations, setShowPopup}) => {
    const sortedCancellations = [...(cancellations || [])].sort(
        (a, b) => new Date(b.dateTime) - new Date(a.dateTime)
    )

    const cancellationLabel = cancellations?.[0]?.teacherCancelled
        ? 'Teacher cancellations'
        : 'Family cancellations'

    return (
        <div className='ugly-cancellations-popup__backdrop' onMouseDown={() => setShowPopup(null)}>
            <div className='ugly-cancellations-popup' onMouseDown={(event) => event.stopPropagation()}>
                <div className='ugly-cancellations-popup__header'>
                    <div>
                        <div className='ugly-cancellations-popup__kicker'>{cancellationLabel}</div>
                        <div className='ugly-cancellations-popup__title'>{cancellations?.[0]?.teacherName || cancellations?.[0]?.familyName || 'Cancellation details'}</div>
                    </div>
                    <div className='ugly-cancellations-popup__x' onClick={() => setShowPopup(null)}>x</div>
                </div>
                <div className='ugly-cancellations-popup__body'>
                    {sortedCancellations.map((cancellation, index) => (
                        <div key={`${cancellation.id || cancellation._id || index}-${cancellation.dateTime}`} className='ugly-cancellations__each-cancellation'>
                            <div className='ugly-cancellations__each-cancellation__top-row'>
                                <div className='ugly-cancellations__each-cancellation__name'>{cancellation.studentName} {cancellation.familyName}</div>
                                <div className='ugly-cancellations__each-cancellation__date'>{format(new Date(cancellation.dateTime), 'MM/dd/yy')}</div>
                            </div>
                            <div className='ugly-cancellations__each-cancellation__reason'>{cancellation.reason || 'No reason provided'}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default UglyCancellationsPopup
